module.exports = __webpack_public_path__ + "static/media/Aditya.fb33c428.jpg";